import { render, staticRenderFns } from "./MainStream.vue?vue&type=template&id=39f236aa&"
import script from "./MainStream.vue?vue&type=script&lang=js&"
export * from "./MainStream.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports